/* eslint-disable @typescript-eslint/naming-convention */
import React from "react"
import { Box, Flex, Heading, Text, Button } from "@chakra-ui/react"
import { StaticPageHeader } from "../../components/commons/static-page-header"
import { breadCrumbFirstLevel, Paths } from "../../common/commonConstants"
import { BreadCrumb } from "../../components/commons/breadcrumb"
import { useNavigate } from "react-router"
import { uniqueSolutionsImg } from "../../components/images"
import { chakraTheme } from "../../theme/chakraTheme"
import { SimpleGridWrapper, SubPage, SubPageContent } from "../../components/SubPage"

export const ReportsAndResources = (): JSX.Element => {
  // const linkStyle = {
  //   lineHeight: '20px',
  //   color: chakraTheme.colors.primary
  // }
  const navigate = useNavigate()
  const navigateTo = (link: string): void => {
    navigate(link)
  }
  // const handleClick = (link: string): void => {
  //   navigate(link)
  // }

  const allReports = [
    {
      label: "Test Reports",
      onClickLink: Paths.TEST_REPORTS
    },
    {
      label: "Installation Instructions",
      onClickLink: Paths.INSTALLATION_INSTRUCTIONS
    },
    {
      label: "Unique Solutions",
      onClickLink: Paths.UNIQUE_SOLUTIONS
    },
    {
      label: "FAQs",
      onClickLink: Paths.FAQ
    },
    {
      label: "Product Drawing & Revit Files",
      onClickLink: Paths.DRAWINGS
    },
    {
      label: "Understanding Compliance",
      onClickLink: Paths.COMPLIANCE
    },
    {
      label: "Quality Certification",
      onClickLink: Paths.QUALITY
    }
  ]

  return (
    <SubPage>
      <StaticPageHeader title="Reports & Resources" bg={uniqueSolutionsImg} />
      <BreadCrumb
        options={{
          ...breadCrumbFirstLevel,
          thirdLevel: { title: "Reports & Resources" }
        }}
      />
      <Box
        textAlign={"center"}
        w={["328px", "328px", "580px"]}
        px={["0px", "0px", 0]}
        margin="auto"
        flexWrap={"wrap"}
        className="aboutus"
        mt={["24px", "24px", "28px"]}
      >
        <Text variant={["RBody", "RBody", "Body1Regular"]} color={"blackText"} mb="8px">
          Test reports & product resources can be found below to ensure compliance.
        </Text>
        <Text variant={["RBody", "RBody", "Body1Regular"]} color={"blackText"}>
          If you are looking for a specific application, go to the relevant&nbsp;
          <Button
            variant="linkButtonBig"
            fontSize={"16px"}
            bottom="2px"
            onClick={() => {
              navigateTo(Paths.Product.all)
            }}
          >
            Product Page
          </Button>
          .<br />
        </Text>
      </Box>
      <SubPageContent innerBoxProps={{ px: "0" }}>
        <SimpleGridWrapper props={{ columns: [2, 3, 3, 3, 3, 3] }}>
          {allReports?.map(({ label, onClickLink }, index) => (
            <React.Fragment key={`${index}_allCollars`}>
              <Flex
                onClick={() => {
                  navigateTo(onClickLink)
                }}
                align="center"
                justify={"center"}
                w={["100%", "100%", "280px"]}
                height={["139px", "139px", "250px"]}
                borderRadius={"10px"}
                sx={{ boxShadow: "0px 6px 20px 0px rgba(0, 0, 0, 0.25)" }}
                mx={[
                  `${index < allReports.length - 1 ? 0 : "55%"}`,
                  `${index < allReports.length - 1 ? 0 : "10px"}`,
                  `${index < allReports.length - 1 ? 0 : "108%"}`
                ]}
                cursor={"pointer"}
              >
                <Heading
                  w={["117px", "117px", "210px"]}
                  variant={["RHeading3Work", "RHeading3Work", "Heading3Work"]}
                  textAlign={"center"}
                  color={chakraTheme.colors.primary}
                >
                  {label}
                </Heading>
              </Flex>
            </React.Fragment>
          ))}
        </SimpleGridWrapper>
      </SubPageContent>
    </SubPage>
  )
}
